/* eslint-disable ember/no-computed-properties-in-native-classes */
import Response from '@linc-technologies/linced-common/models/surveys/response';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import type Person from 'linced-app/models/person';

// Proto: surveys.SurveyResponse.
export default class _Response extends Response {
  declare [Type]: 'surveys/response';

  @belongsTo('person', { async: true, inverse: null })
  // @ts-expect-error a person relationship replaces the common string id.
  declare authorId: AsyncBelongsTo<Person>;

  @alias('authorId')
  declare author: AsyncBelongsTo<Person>;

  @alias('person.id')
  declare person_id: string | null | undefined;

  @computed('createTime', 'updateTime')
  get responseTime() {
    return this.updateTime || this.createTime;
  }
}
